import ExamApplicationModel from '@/dex-shared/models/ExamApplicationModel';
import SubjectModel from '@/models/SubjectModel';
import BoardSectionModel from '@/dex-shared/models/BoardSectionModel';
import MaterialModel from '@/dex-shared/models/MaterialModel';
import ExamModeModel from '@/dex-shared/models/ExamModeModel';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  subjects: (state: any, getters: any) => {
    return Object.values(state.questions).map(
      (subject: any) => new SubjectModel(subject, getters),
    );
  },
  materials: (state: any, getters: any) => {
    return Object.values(state.materials).map(
      (material: any) => new MaterialModel(material, getters),
    );
  },
  highlightedSubjects: (state: any, getters: any) => {
    return getters.materials
      .filter((material: MaterialModel) => material.highlighted)
      .map((material: MaterialModel) => material.subject());
  },
  subjectById: (state: any, getters: any) => (subjectId: number) => {
    let subject = state.questions[subjectId];
    if (subject) {
      return new SubjectModel(subject, getters);
    } else {
      return {};
    }
  },
  subjectBySlug: (state: any, getters: any) => (slug: string) => {
    let subject = Object.values(state.questions).find(
      (subject: any) => subject.slug == slug,
    );
    if (subject) {
      return new SubjectModel(subject, getters);
    } else {
      return {};
    }
  },
  contentsByQuestionId: (state: any, getters: any) => (questionId: number) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.questionId === questionId);
  },
  examApplications: (state: any, getters: any) => {
    return Object.values(state.exam_applications).map(
      (examApplication: any) =>
        new ExamApplicationModel(examApplication, getters),
    );
  },
  examApplicationById: (state: any, getters: any) => (examId: number) => {
    let examApplication = state.exam_applications[examId];
    if (examApplication) {
      return new ExamApplicationModel(examApplication, getters);
    } else {
      return {};
    }
  },
  materialById: (state: any, getters: any) => (materialId: number) => {
    let material = state.materials[materialId];
    if (material) {
      return new MaterialModel(material, getters);
    } else {
      return {};
    }
  },
  examModes: (state: any, getters: any) => {
    return Object.values(state.exam_modes).map(
      (examMode: any) => new ExamModeModel(examMode, getters),
    );
  },
  examModeById: (state: any, getters: any) => (examModeId: number) => {
    let examMode = state.exam_modes[examModeId];
    if (examMode) {
      return new ExamModeModel(examMode, getters);
    } else {
      return {};
    }
  },
  boardSections: (state: any, getters: any) => {
    return Object.values(state.board_sections).map(
      (boardSection: any) => new BoardSectionModel(boardSection, getters),
    );
  },
  boardSectionById: (state: any, getters: any) => (boardSectionId: number) => {
    let boardSection = state.board_sections[boardSectionId];
    if (boardSection) {
      return new BoardSectionModel(boardSection, getters);
    } else {
      return {};
    }
  },
};
